const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M124.12,262.27V60.34a29.15,29.15,0,0,1,29.09-29.09H366.94A29.15,29.15,0,0,1,396,60.34V262.27a.94.94,0,0,0,.94.93H446.9a.92.92,0,0,1,.87.59.91.91,0,0,1-.22,1c-21.35,20.66-43.21,41.25-64,62a.92.92,0,0,1-1,.2.93.93,0,0,1-.57-.87V60.34a15.12,15.12,0,0,0-15.05-15.05H153.21a15.12,15.12,0,0,0-15.05,15.05V334a.93.93,0,0,1-1.58.67c-24.05-23.15-48.1-46.52-72.14-69.82a.94.94,0,0,1,.65-1.61h58.09a.94.94,0,0,0,.94-.93Zm333.8,12-100.12,97a.92.92,0,0,0-.29.68.9.9,0,0,0,.29.67l100.12,97a.94.94,0,0,0,1.59-.68V275a.94.94,0,0,0-1.59-.67Zm-290.41,105a.88.88,0,0,1,.65-.27H343.84a.91.91,0,0,1,.66.27l103.06,99.88a.93.93,0,0,1-.65,1.6H65.09a.93.93,0,0,1-.65-1.6Zm-13.31-8-100.12-97a.9.9,0,0,0-1-.19.92.92,0,0,0-.58.86V469a.92.92,0,0,0,.58.86.9.9,0,0,0,1-.19l100.12-97a.92.92,0,0,0,0-1.34ZM171.88,263.2H348.27a7,7,0,0,0,0-14H171.88a7,7,0,0,0,0,14Zm0,57.9H348.27a7,7,0,0,0,0-14.05H171.88a7,7,0,0,0,0,14.05Z",
    style: {
      fill: "#0096ff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.88,102.11q7.62,0,12,4.77t4.42,12.36a17.63,17.63,0,0,1-4.42,12.32q-4.41,4.86-12.52,4.87t-12.24-4.85a17.9,17.9,0,0,1-4.28-12.29A17.48,17.48,0,0,1,186.37,107Q190.86,102.11,198.88,102.11Zm-.29,7q-6.72,0-6.72,10a14.38,14.38,0,0,0,1.68,7.51,5.6,5.6,0,0,0,5.13,2.76q6.73,0,6.73-10.08Q205.41,109.11,198.59,109.12Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.67,135.8V102.73h24.72v7.2H230.17v6.43h14.26v7.2H230.17V135.8Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24,135.8V102.73H275v7.2H259.74v6.43H274v7.2H259.74V135.8Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.19,115.26v7.15H289.11v6.19H306l-1.1,7.2H279.8V102.73h25v7.2h-15.7v5.33Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.24,123.32h-3.41V135.8h-9.4V102.73h16.36c3.75,0,6.61.87,8.6,2.59a8.35,8.35,0,0,1,3,6.58,8,8,0,0,1-4.94,7.82c2.85,1,4.27,3.84,4.27,8.55v1.39a30.34,30.34,0,0,0,.43,6.14h-9.21q-.68-1.81-.68-7.2v-.86a4.76,4.76,0,0,0-1-3.38C326.59,123.67,325.26,123.32,323.24,123.32Zm-3.41-13.82v7.06h4.52q4.36,0,4.36-3.56t-4.36-3.5Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.68,181V147.93h9.74V173.8H196l-1.05,7.2Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.1,160.46v7.15H209v6.19h16.85l-1.11,7.2H199.72V147.93h25v7.2H209v5.33Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.83,181V155.13h-9.46v-7.2h28.51v7.2h-9.36V181Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.51,181V155.13h-9.46v-7.2h28.51v7.2H279.2V181Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.88,160.46v7.15H301.81v6.19h16.85l-1.11,7.2H292.5V147.93h25v7.2h-15.7v5.33Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.94,168.52h-3.41V181h-9.41V147.93h16.37c3.74,0,6.61.87,8.59,2.59a8.36,8.36,0,0,1,3,6.58,8.15,8.15,0,0,1-1.47,5.06,8.06,8.06,0,0,1-3.48,2.76c2.85,1,4.27,3.84,4.27,8.55v1.39a30.16,30.16,0,0,0,.44,6.14H341.6q-.68-1.81-.67-7.2v-.86a4.81,4.81,0,0,0-1-3.38C339.29,168.87,338,168.52,335.94,168.52Zm-3.41-13.82v7.06H337q4.36,0,4.37-3.56T337,154.7Z",
    style: {
      fill: "#0096ff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature3);
export default __webpack_public_path__ + "static/media/feature3.813cde8eeb715644bb851726e1c64dcd.svg";
export { ForwardRef as ReactComponent };